import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import { HashLink } from 'react-router-hash-link';


class Cigerate extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
            <div>
                <Navbar head="Cigarrete" />
                <div className="container" style={{ marginTop: "60px" }}>
                    <HashLink to='/faq#cigarette'>
                        <button id="myBtn" title="FAQ">
                            <i class="fas fa-info-circle faqicon"></i>
                            <p>  FAQ</p>
                        </button>
                    </HashLink>


                    <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                        <img className="img-fluid" src="/assests/images/educationCigarette.png" alt="cigarette">
                        </img>
                        
                        </div>
                    </div>

                    <div className="content">
                        <h2>Cigeratte</h2>
                        <h4>
                            Nicotine/Tobacco
                    </h4>
                        <p>Tobacco is a plant grown for its leaves, which are dried and fermented before using them in tobacco products. Tobacco contains nicotine, an ingredient that can lead to addiction.</p>

                        <h4>
                            How do people use it?
                    </h4>
                        <p>
                            People can smoke, chew or sniff tobacco. Smoked tobacco products include cigarettes, cigars, bidis, and kreteks. Another form is to take it through loose tobacco in a pipe or hookah. Chewed tobacco products include chewing tobacco, dip and snuff. Snuff can also be sniffed.
                    </p>

                        <h4>Nicotine Overdose</h4>
                        <p>
                            Although it's uncommon, but nicotine overdose is possible. Nicotine poisoning occurs in young children who accidentally chew on nicotine gum or patches used to quit smoking. Symptoms include difficulty in breathing, fainting, headache, weakness and increased heart rate.
                    </p>

                        <h4>
                            Impact of Tobacco/Nicotine
                    </h4>
                        <ul>
                            <li><p>Nicotine stimulates the adrenal glands causing an <b>increase in blood pressure, heart rate and breathing.</b></p></li>
                            <li><p>Tobacco smoking can lead to <b>lung cancer, chronic bronchitis.</b></p></li>
                            <li><p>Increases the <b>risk of heart disease</b>which leads to<b> stroke or heart attack.</b></p></li>
                            <li><p>Smoking leads to <b>other cancers, leukemia, cataracts and pneumonia.</b></p></li>
                            <li><p>Pregnant women are more susceptible to an <b>increased risk of miscarriage</b>stillborn or premature infants or infants with low birth weight.</p></li>

                        </ul>

                        <h4>Withdrawal symptoms of quitting involves-</h4>
                        <ul>
                            <li><p>Irritability</p></li>
                            <li><p>Trouble sleeping</p></li>
                            <li><p>Increased appetite</p></li>
                            <li><p>Strong urges(cravings) for tobacco</p></li>
                            <li><p>Problems paying attention</p></li>
                        </ul>

                        <h4>Electronic Cigarettes-</h4>
                        <p>Electronic cigarettes, or e-cigarettes, are <b>battery operated devices</b> that deliver flavoured nicotine with other chemicals as <b>vapour instead of smoke</b>. E-cigarettes are advertised as being safer than traditional cigarettes because they don’t burn tobacco. They are also called e-cigs, hookah pens, vapes, vape pens, mods.</p>

                        <p>
                            While some research suggests that e-cigarettes may be less harmful than normal ones, it is acknowledged that <b>nicotine in any form is addictive and can act as a gateway drug</b> which puts users at risk of addiction from other drugs. The use of e-cigarettes exposes the lungs to a range of chemicals and certain studies suggest that the vapour <b>contains known carcinogens</b> and toxic chemicals, as well as potentially toxic metal nanoparticles from the device itself.
                        </p>

                        <h4>Nicotine Replacement Therapy (NRT)</h4>
                        <p>NRT is a <b>coping strategy that provides nicotine in other forms</b> such as gum, patches, sprays, inhalers, or lozenges- cancelling the other harmful chemicals in tobacco. NRT can help <b>relieve some of the physical withdrawal symptoms</b> so that individuals can focus on the psychological aspects of nicotine use.</p>

                        <h4>Nicotine Patches</h4>

                        <p>Depending on body size and smoking habits, most smokers should start by using a full-strength patch (15-22 mg of nicotine) daily for 4 weeks, and then use a weaker patch (5-14 mg of nicotine) for another 4 weeks. The use of patches should be systematically reduced.</p>

                        <p>Possible side effects include-</p>
                        <ul>
                        <li><p>Skin irritation</p></li>
                        <li><p>Dizziness</p></li>
                        <li><p>Racing heartbeat</p></li>
                        <li><p>Sleep disturbances, unusual dreams</p></li>
                        <li><p>Headache, nausea</p></li>
                        <li><p>Muscle ache and stiffness</p></li>
                        </ul>
                        

                        <h4>Nicotine Gum</h4>
                        <p>A fast-acting replacement for traditional nicotine intake, it is taken in the form of chewing gums. Possible side effects can include-</p>
                        <ul>
                        <li><p>Bad taste</p></li>
                        <li><p>Throat irritation</p></li>
                        <li><p>Mouth sores</p></li>
                        <li><p>Hiccups</p></li>
                        <li><p>Nausea</p></li>
                        <li><p>Jaw discomfort</p></li>
                        <li><p>Racing Heartbeat</p></li>
                        <li><p>The gum can also stick and cause damage to dentures and dental work.</p></li>
                        </ul>

                        <h4>Nicotine Nasal Spray</h4>
                        <p>The nasal spray delivers nicotine to the bloodstream quickly because it is absorbed through the nose. It quickly relieves individual from withdrawal symptoms and controls nicotine craving.
                        Side effects may include-
                        </p>
                        <ul>
                        <li><p>Nasal irritation</p></li>
                        <li><p>Runny nose</p></li>
                        <li><p>Watery eyes</p></li>
                        <li><p>Sneezing</p></li>
                        <li><p>Throat irritation, coughing</p></li>
                        </ul>
                        
                        <h4>
                        Nicotine Inhaler
                        </h4>
                        <p>
                        The nicotine inhaler is a thin plastic tube with a nicotine cartridge inside. Unlike other inhalers, which deliver most of the medicine to the lungs, the nicotine inhaler delivers most of the nicotine vapour to the mouth where it’s absorbed into the bloodstream. They are a nicotine replacement method that’s almost like smoking a cigarette.
                        </p>
                        <p>Possible side effects of nicotine inhalers can include-</p>
                        <ul>
                        <li><p>Coughing</p></li>
                        <li><p>Mouth and/or throat irritation</p></li>
                        <li><p>Runny nose</p></li>
                        <li><p>Upset stomach</p></li>
                        </ul>
                        
                        
                    </div>
                </div>
            </div>

        )
    }
}

export default Cigerate;